module.exports = __webpack_public_path__ + "img/2025-09-19c_4.b418b947.jpg";